import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

const SearchTextField = styled(TextField)(() => ({
  width: '100%',
}));

export { SearchTextField };
